module.exports = __webpack_public_path__ + "02_glasses_red.ace1e71b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer4/02_glasses_red.png
// module id = tkxF
// module chunks = 0